import { useRequest } from "../../utils/api"
import { ListLocationResponseType, LocationTypeProps } from "./index.type"

const GET_LIST_LOCATION = '/v1/rms/location/'
export const DEFAULT_LOCATION_LIMIT = 100
export const useLocationPoints = (type ?: LocationTypeProps, obj = {} as { enabled?: boolean, pageSize?: number, page?: number }) => {
  return useRequest<ListLocationResponseType>(GET_LIST_LOCATION, {
    ...obj,
    type: type || 'all',
    page_size: obj.pageSize || DEFAULT_LOCATION_LIMIT,
    page: obj.page || 1,
  }, {
    enabled: obj.enabled
  })
}